module.exports = __webpack_public_path__ + "img/店外三件套 (1).50cd853d.png";